export const movements = {
      title: 'Movements',
      subtitle: 'Inbound, outbound, adjustments, and transfers',
      recordsTitle: 'Movement history',
      recordsDescription: 'Review and record inbound, outbound, adjustment, and transfer movements.',
      new: '+ New movement',
      createTitle: 'Record movement',
      createSubtitle: 'Capture an inbound, outbound, adjustment, or transfer inventory movement.',
      emptyTitle: 'No movements available',
      emptyDescription: 'There are no movements matching the selected filter.',
      allTypes: 'All',
      inbound: 'Inbound',
      outbound: 'Outbound',
      adjustment: 'Adjustment',
      transfer: 'Transfer',
      destinationWarehouse: 'Destination warehouse',
      quantityMode: 'Capture type',
      baseUnit: 'Unit',
      preferredUnitSwitch: 'Unit',
      preferredUnitSwitchHint: 'Converts balances and quantities to the product preferred unit.',
      unitCost: 'Unit cost',
      unitCostReferenceHint: 'Cost per {{unit}}. The last known cost is prefilled as a reference.',
      unitCostPackagingHint: 'If quantity is captured in {{packaging}}, the cost still applies per {{unit}}.',
      stockSummaryTitle: 'Current stock',
      totalStock: 'Total stock',
      warehouseStock: 'Stock by warehouse',
      warehouseStockWithName: 'Stock in {{warehouse}}',
      operatedUnitCost: 'Movement unit cost',
      operatedUnitCostLastCost: 'Based on the last recorded cost.',
      operatedUnitCostAverageCost: 'Based on the warehouse average cost.',
      movementTotalCost: 'Total movement cost',
      detailsTitle: 'Movement details',
      movementTypeName: 'Movement type',
      relatedWarehouse: 'Related warehouse',
      viewDetails: 'View information',
      balanceBefore: 'Stock before',
      balanceAfter: 'Stock after',
      sourceWarehouseBalance: '{{warehouse}}: {{balance}}',
      destinationWarehouseBalance: '{{warehouse}}: {{balance}}',
      selectWarehouseForStock: 'Select a warehouse',
      destinationWarehouseMustDiffer: 'Destination warehouse must be different from the source warehouse.',
      notes: 'Notes',
      quantityInsufficientStock: 'The movement cannot leave inventory with negative quantity.',
      quantityMustBePositiveInbound: 'Inbound quantity must be positive.',
      quantityMustBeNegativeOutbound: 'Outbound quantity must be negative.',
      quantityMustBeNegativeTransfer: 'Transfer quantity must be negative from the source warehouse.',
      quantityInHint: 'Enter a positive quantity to increase inventory.',
      quantityOutHint: 'Enter a positive quantity; it will be recorded as an outbound movement.',
      quantityTransferHint: 'Enter a positive quantity; it will be subtracted from the source warehouse and added to the destination.',
      quantityAdjustmentHint: 'Use a positive value to increase inventory or a negative value to decrease it.',
      quantityPackagingHint: 'Each {{packaging}} equals {{quantity}} {{unit}}.',
    } as const;
